import React from "react";
import type { DocumentElement as DocumentElementType } from "@eaco/forms-core";

import DocumentElement from "../DocumentView/DocumentElement";

interface Props {
  element: DocumentElementType;
}

/**
 * A card: a stack of child blocks inside a bordered, white panel. Like the
 * callout it's a container — children are authored on the canvas; this renderer
 * is the read/fill/print view, stacking child blocks via the element dispatcher.
 */
const PageCard: React.FC<Props> = ({ element }) => {
  const children = element.elements || [];
  return (
    <div className="rounded-[10px] border border-[#e7e5e1] bg-white px-[17px] py-[15px] shadow-[0_1px_2px_rgba(20,18,15,0.04)]">
      <div className="space-y-1">
        {children.map((child) => (
          <DocumentElement key={child.id} element={child} />
        ))}
      </div>
    </div>
  );
};

export default PageCard;
